define([
  'app/modules/map',
  'app/modules/job_wizard',
  'app/modules/job',
  'app/modules/filteringList',
  'app/modules/utilities',
  'scriptjs'
], (googleMap, JobWizard, Job, FilteringList, Util, $script) => {
  const Jobs = function() {};

  Jobs.prototype.actionEdit = Jobs.prototype.actionUpdate = Jobs.prototype.actionNew = Jobs.prototype.actionCreate = function() {
    const job_employment_type = $('#job_employment_type');

    JobWizard.initSuggestions();
    JobWizard.checkEmploymenType(job_employment_type.val());

    job_employment_type.on('change', function() {
      JobWizard.checkEmploymenType($(this).val());
    });

    const start_date_el = $('#job_start_date');
    const deadline_el = $('#job_deadline');

    start_date_el
      .datetimepicker({
        format: 'MM.YYYY',
        viewMode: 'months',
        useCurrent: false
      })
      .on('dp.change', function() {
        const currentDay = new Date().getUTCDate();
        const currentMonth = new Date().getUTCMonth() + 1;
        const selected_date =
          $(this).val() &&
          $(this)
            .val()
            .split('.')
            .slice(-2);
        const newDay = selected_date[0] != currentMonth ? '01' : currentDay + 1;
        if (!deadline_el.val() && $(this).val()) {
          deadline_el.val(`${newDay}.${$(this).val()}`);
        }
      });

    deadline_el
      .datetimepicker({
        format: 'DD.MM.YYYY',
        viewMode: 'days',
        useCurrent: false
      })
      .on('dp.change', function() {
        const new_date =
          $(this).val() &&
          $(this)
            .val()
            .split('.')
            .slice(-2)
            .join('.');
        if (!start_date_el.val() && new_date) start_date_el.val(new_date);
      });
  };

  Jobs.prototype.actionShow = function() {
    Job.disable($('.disabled-apply'));

    $script.ready('google-maps', () => {
      const mapCanvas = document.getElementById('map');
      if (mapCanvas) {
        const lat = $(mapCanvas).attr('data-lat');
        const lon = $(mapCanvas).attr('data-lon');
        googleMap.init(mapCanvas, { zoom: 12, lat, lon }).then(map => {
          googleMap.addMarker(map, { lat, lon });
        });
      }
    });
  };

  Jobs.prototype.actionIndex = function() {
    new FilteringList({
      onSuccess: this.updateList
    });
  };

  Jobs.prototype.updateList = function(results) {
    const $list = $('.js-filtering-list');

    if (results.jobs_html) {
      if (results.clear_content) {
        $list.html(results.jobs_html);
      } else {
        $list.append(results.jobs_html);
      }
    }
  };

  Jobs.prototype.actionAdvertising = function() {
    $('input.job-board-checkbox')
      .iCheck({ handle: 'checkbox' })
      .on('ifChecked', function() {
        const boardId = $(this).val();
        const authParams = $(`#board-${boardId}`);
        const boardLogin = authParams.find('.job-board-login');
        const boardPassword = authParams.find('.job-board-password');
        if (boardLogin && boardPassword && (boardLogin.val() == '' || boardPassword.val() == '')) {
          authParams.addClass('visible');
        }
      });
  };

  return Jobs;
});
